// test1289
(1289 && 0);
